/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { OperatorsListDto, OperatorsListFilterParams } from '../api/operators/operatorsClient.typings';
import { createAction } from '../../utils/redux-utils';
import { Notification, NOTIFICATION_TYPES } from '../../utils/utils';
import { i18n } from '../translation/i18n';

export enum OperatorsActionType {
    OPEN_REGISTRY_OPERATORS_LIST_PAGE = 'RegistryOperatorsList/ open page',
    EXIT_REGISTRY_OPERATORS_LIST_PAGE = 'RegistryOperatorsList/ exit page',

    FETCH_NEXT_PAGE_START = 'RegistryOperatorsList/ fetch next page start',
    APPLY_FILTER = 'RegistryOperatorsList/ apply filter',

    CHANGE_FILTERS = 'RegistryOperatorsList/ change filters',

    DOWNLOAD_EXCEL = 'RegistryOperatorsList/ download operators list as excel',
    DOWNLOAD_EXCEL_SUCCESS = 'RegistryOperatorsList/ download operators list as excel success',
    DOWNLOAD_EXCEL_ERROR = 'RegistryOperatorsList/ download operators list as excel error',

    FETCH_OPERATORS_LIST_SUCCESS = 'RegistryOperatorsList/ fetch operators list success',
    FETCH_OPERATORS_LIST_ERROR = 'RegistryOperatorsList/ fetch operators list error',
}

export const openRegistryOperatorsListAction = () =>
    createAction(OperatorsActionType.OPEN_REGISTRY_OPERATORS_LIST_PAGE);

export const exitRegistryOperatorsListAction = () =>
    createAction(OperatorsActionType.EXIT_REGISTRY_OPERATORS_LIST_PAGE);

export const applyFilteringAction = () => createAction(OperatorsActionType.APPLY_FILTER);

export const fetchNextPageStartAction = () => createAction(OperatorsActionType.FETCH_NEXT_PAGE_START);

export const changeFiltersAction = (params: OperatorsListFilterParams) =>
    createAction(OperatorsActionType.CHANGE_FILTERS, params);

export const downloadOperatorsListAsExcelAction = () => createAction(OperatorsActionType.DOWNLOAD_EXCEL);

export const downloadOperatorsListAsExcelSuccessAction = () =>
    createAction(OperatorsActionType.DOWNLOAD_EXCEL_SUCCESS, {
        notification: {
            type: NOTIFICATION_TYPES[1],
            message: i18n.t('downloadings.fileCreationRequestAccepted'),
        },
    });

export const downloadOperatorsListAsExcelErrorAction = (notification: Notification) =>
    createAction(OperatorsActionType.DOWNLOAD_EXCEL_ERROR, { notification });

export const fetchOperatorsListSuccessAction = (list: OperatorsListDto) =>
    createAction(OperatorsActionType.FETCH_OPERATORS_LIST_SUCCESS, {
        list,
        notification:
            list.operators.length === 0
                ? {
                      type: NOTIFICATION_TYPES[1],
                      message: i18n.t('errors.notFoundByParams'),
                  }
                : null,
    });

export const fetchOperatorsListErrorAction = (notification: Notification) =>
    createAction(OperatorsActionType.FETCH_OPERATORS_LIST_ERROR, { notification });

export type OperatorsActions =
    | ReturnType<typeof fetchNextPageStartAction>
    | ReturnType<typeof openRegistryOperatorsListAction>
    | ReturnType<typeof exitRegistryOperatorsListAction>
    | ReturnType<typeof applyFilteringAction>
    | ReturnType<typeof changeFiltersAction>
    | ReturnType<typeof downloadOperatorsListAsExcelAction>
    | ReturnType<typeof downloadOperatorsListAsExcelSuccessAction>
    | ReturnType<typeof downloadOperatorsListAsExcelErrorAction>
    | ReturnType<typeof fetchOperatorsListSuccessAction>
    | ReturnType<typeof fetchOperatorsListErrorAction>;
